<div class="k-d-flex k-justify-content-between k-gap-md m-b-4 fit-content-width">
    <a
      class="summary-link"
      [routerLink]="['/reports/history-summary']"
    >
      < Go Back To Summary
    </a>
<div class="k-d-flex k-justify-content-between k-gap-md m-b-4 fit-content-width align-center">
  <div class="filters-section">
    <ng-container *ngIf="cancelAvailabilityEnabled && hasAvailabilityType">
      <kendo-multiselect
        placeholder="Select restaurant(s) to cancel"
        [data]="restaurants"
        class="restaurant-dropdown"
        [(ngModel)]="selectedRestaurants"
        textField="name"
        valueField="id"
        [filterable]="true"
        (filterChange)="getRestaurants($event)"
      >
      </kendo-multiselect>

      <button *ngIf="selectedRestaurants.length > 0" kendoButton themeColor="error" (click)="cancelAvailabilityConfirmationPopupVisible = true;">Cancel Availability</button>
    </ng-container>

   
  </div>
</div>
</div>
<div class="k-d-flex k-justify-content-between k-gap-md fit-content-width">
  <button *ngFor="let s of statuses" kendoButton (click)="status = s.id; 
  fetchAllSections()" 
  [fillMode]="this.status === s.id ? 'solid' : 'outline'" 
  [themeColor]="s.attributes['color']">
    {{s.name}}
  </button>

  <button kendoButton (click)="fetchAllSections()" rounded="full" fillMode="outline"  themeColor="primary">
    <fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
  </button>
</div>
<div *ngFor="let section of sections" class="history-section">
  <h4 class="m-b-2">{{ section.type }}</h4>

  <app-data-grid
    [dataItems]="section.changesets"
    [columns]="section.columns"
    [state]="section.state"
    [group]="group"
    [fontSize]="fontSize"
    [paginate]="false"
    [filterable]="'menu'"
    (filterChange)="onFilterChange(section, $event)"
  >

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="parItemId"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="restaurantName"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="itemName"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="componentName"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="componentType"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      filterTemplate
      let-column="column"
      let-filterService="filterService"
      field="modifierCode"
    >
      <app-custom-filter
        [view]="'history-detail'"
        [lazy]="false"
        [extraParams]="section.distinctParams"
        [filter]="section.state.filter"
        [preselected]="section.filterCache.get(column.field) || []"
        (filterChanged)="
          onCustomFilterChange(section, column.field, $event, filterService)
        "
        [field]="column.field"
        [type]="column.type"
      ></app-custom-filter>
    </ng-template>

    <ng-template
      columnTemplate
      let-row="row"
      let-column="column"
      field="transmitStatus"
    >
      <ng-container [ngSwitch]="row[column.field]">
        <fa-icon
          *ngSwitchCase="'Success'"
          [icon]="['fas', 'check-circle']"
          class="text-success"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Failed'"
          [icon]="['fas', 'times-circle']"
          class="text-danger"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Pending'"
          [icon]="['fas', 'hourglass-half']"
          class="text-warning"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Scheduled'"
          [icon]="['fas', 'calendar-check']"
          class="text-success"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Canceled'"
          [icon]="['fas', 'ban']"
          class="text-danger"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchDefault
          [icon]="['fas', 'question-circle']"
          class="text-muted"
          [title]="row[column.field]"
        ></fa-icon>
      </ng-container>
    </ng-template>

    <ng-template
      columnTemplate
      let-row="row"
      let-column="column"
      field="dataStatus"
    >
      <ng-container [ngSwitch]="row[column.field]">
        <fa-icon
          *ngSwitchCase="'Success'"
          [icon]="['fas', 'check-circle']"
          class="text-success"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Pending'"
          [icon]="['fas', 'hourglass-half']"
          class="text-warning"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Canceled'"
          [icon]="['fas', 'ban']"
          class="text-danger"
          [title]="row[column.field]"
        ></fa-icon>
        <fa-icon
          *ngSwitchDefault
          [icon]="['fas', 'question-circle']"
          class="text-muted"
          [title]="row[column.field]"
        ></fa-icon>
      </ng-container>
    </ng-template>

    <ng-template
      groupColumnHeaderTemplate
      field="scheduledHour"
      let-group="group"
      let-column="column"
    >
      <div class="k-d-flex k-justify-content-center k-align-items-center k-gap-md">
        <span>
          Scheduled For:
          <strong>{{ group.value ? (group.value | date: 'MM/dd HH:mm') : 'Not scheduled' }}</strong>
          ({{ group.items.length }} {{ group.items.length === 1 ? 'change' : 'changes' }})
        </span>

        <button
          *ngIf="showEditButton(group.items)"
          kendoButton
          (click)="openRescheduleDialog(group.items)"
          themeColor="primary"
          rounded="full"
          fillMode="flat"
          [title]="'Reschedule all changes in this group'"
        >
          <fa-icon class="m-r-0" [icon]="['fas', 'pen']" size="sm"></fa-icon>
        </button>
      </div>
    </ng-template>

    <ng-template
      columnTemplate
      field="newDeliveryAvailability3P"
      let-row="row"
      let-column="column"
    >
      <app-column
        [fontSize]="fontSize"
        [data]="row"
        [column]="column"
        *ngIf="row.newDeliveryAvailability3P != null"
      >
      </app-column>

      <p class="m-0 italic-text" *ngIf="row.newDeliveryAvailability3P == null">No changes</p>
    </ng-template>

    <ng-template
      columnTemplate
      field="newAvailability"
      let-row="row"
      let-column="column"
    >
      <app-column
        [fontSize]="fontSize"
        [data]="row"
        [column]="column"
        *ngIf="row.newAvailability != null"
      >
      </app-column>

      <p class="m-0 italic-text" *ngIf="row.newAvailability == null">No changes</p>
    </ng-template>

    <ng-template
      columnTemplate
      field="restaurantTimestamp"
      let-row="row"
      let-column="column"
    >
      <span class="k-d-flex">
        <app-column
          [fontSize]="fontSize"
          [data]="row"
          [column]="column"
        >
          <ng-template #content>
            {{ row.restaurantTimezone }}
          </ng-template>
        </app-column>
      </span>
    </ng-template>

  </app-data-grid>
</div>

<kendo-dialog
  [width]="700"
  *ngIf="selectedToReschedule"
  (close)="selectedToReschedule = null"
>
  <kendo-dialog-titlebar> Reschedule Changeset </kendo-dialog-titlebar>

  <kendo-datetimepicker
    adaptiveMode="auto"
    [size]="'small'"
    class="schedule-datepicker"
    [popupSettings]="{ appendTo: 'component', popupClass: 'custom-popup' }"
    [(ngModel)]="rescheduledDate"
  ></kendo-datetimepicker>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="selectedToReschedule = null">Cancel</button>
    <button
      kendoButton
      (click)="rescheduleChangeset(selectedToReschedule, rescheduledDate)"
      themeColor="primary"
    >
      Reschedule
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog
  [width]="700"
  *ngIf="cancelAvailabilityConfirmationPopupVisible"
  (close)="cancelAvailabilityConfirmationPopupVisible = false"
>
  <kendo-dialog-titlebar> Cancel Availability </kendo-dialog-titlebar>

  This action will cancel all scheduled availability changes for restaurants:
  <ul>
    <li *ngFor="let restaurant of selectedRestaurants">{{ restaurant.name }}</li>
  </ul>
  The changes will be pending for you to sync again or remove. 
  Are you sure you want to proceed?

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="cancelAvailabilityConfirmationPopupVisible = false">No</button>
    <button
      kendoButton
      (click)="cancelAvailability(); cancelAvailabilityConfirmationPopupVisible = false"
      themeColor="error"
    >
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
